<template>
  <div>
    <div class="footer-bg" v-if="showBg"></div>
    <div class="footer-wrapper">
      <div class="footer-item">
        <span>常用系统链接：</span>
        <a href="#">BPM系统</a>
        <a href="#">i-Target系统</a>
      </div>
      <div class="footer-item" v-if="showHelp">
        <router-link to="/user/faq" class="link-text">常见问题</router-link>
      </div>
      <div class="footer-item">
        <router-link v-if="userInfo" to="/user/contact" class="link-text">联系客服</router-link>
        <span v-else class="link-button" @click="viewContactInfo">联系客服</span>
      </div>
      <div class="footer-item">
        &copy;2019 AB InBev.  All rights reserved.
      </div>
      <div class="footer-record">
        <span class="link-button">沪ICP备15034922号-5</span>
        <span class="link-button">沪公网安备 31011502008177号</span>
      </div>
    </div>

    <el-dialog :visible.sync="csVisible" title="联系客服" width="30%">
      <p>
        <!-- <b>客服热线：</b>4008-050-979 -->
      </p>
      <p>
        <b>服务时间：</b>周一至周五8:00 - 17:00
      </p>
      <p>
        <b>服务邮箱：</b>apac.icircle@budweiserapac.com
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn-red" @click="csVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <v-form ref="sso-form" :url="ssoUrl" :params="ssoParam" param-mode="field" :with-token="false" />
  </div>
</template>

<script>
import coolerApi from '@/api/cooler'
import { mapGetters } from 'vuex'
import vForm from '@/components/v-form'
export default {
  components: {
    vForm
  },
  props: {
    showHelp: {
      type: Boolean,
      default: true
    },
    showBg: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      csVisible: false,
      ssoUrl: '',
      ssoParam: {
        ssoToken: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  methods: {
    viewContactInfo () {
      this.csVisible = true
    },
    leadToCoolerPlus () {
      console.log('lead to cooler plus')
      coolerApi.getCoolerPlusSsoInfo().then(res => {
        if (res.data.resultCode === '0') {
          this.ssoUrl = res.data.resultData.ssoUrl
          this.ssoParam.ssoToken = res.data.resultData.ssoToken
          this.$refs['sso-form'].submit()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-bg {
  height: 120px;
  background: #f3f5f9 url("../../../assets/images/home_bg.png") center repeat;
  background-size: auto 120px;
}
.footer-wrapper {
  height: 90px;
  padding-bottom: 10px;
  text-align: center;
  font-size: $font-12;
  background-color: #ddd;
  .footer-item {
    // line-height: 100px;
    display: inline-block;
    padding-top: 40px;
    margin-right: 5px;
    a {
      color: $base-black;
      padding-right: 15px;
    }
    .link-text {
      text-decoration: none
    }
    .link-button {
      cursor: pointer;
      &:hover {
        color: $base-red;
      }
    }
    a:hover {
      color: $base-red;
    }
  }
  .footer-record {
    padding-top: 10px;
    span {
      display: inline-block;
      padding: 0 30px;
    }
  }
}
.footer-item:nth-child(1) {
  margin-right: 50px;
}
</style>
